import { createSlice } from "@reduxjs/toolkit";
import { getAllOtherShopAction, insertUpdateOtherShopAction, getOtherShopAction, OtherShopChangeStatusACTION } from "../../actions/settingActions/OtherShopAction";
import { toast } from 'react-toastify';
import { Enums } from "../../../helper/constants/enums";

const INITIAL_STATE = {
    OtherShop: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    insertUpdateOtherShop: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    selectedOtherShop: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    deleteOtherShop: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    }
};

const OtherShopReducer = createSlice({
    name: "OtherShop",
    initialState: INITIAL_STATE,
    reducers: {

        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetOtherShopDetailsState(state, action) {
            state.selectedOtherShop = INITIAL_STATE.selectedOtherShop;
            state.insertUpdateOtherShop = INITIAL_STATE.insertUpdateOtherShop;
        }
    },

    extraReducers: (builder) => {

        builder.addCase(getAllOtherShopAction.fulfilled, (state, action) => {
            // console.log("action.payload.data", action.payload);
            state.OtherShop.data = action.payload.data;
            state.OtherShop.apiMsg.status = action.meta.requestStatus;
            state.OtherShop.apiMsg.message = "success";
            // console.log( "state.User.data",  state.User.data.records);
        });
        builder.addCase(getAllOtherShopAction.pending, (state, action) => {
            state.OtherShop.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllOtherShopAction.rejected, (state, action) => {
            state.OtherShop.apiMsg.message = action.error.message;
            state.OtherShop.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(getOtherShopAction.fulfilled, (state, action) => {
            state.selectedOtherShop.data = action.payload.data;
            state.selectedOtherShop.apiMsg.status = action.meta.requestStatus;
            state.selectedOtherShop.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(getOtherShopAction.pending, (state, action) => {
            state.selectedOtherShop.data = null;
            state.selectedOtherShop.apiMsg.message = action.meta.requestStatus;;
            state.selectedOtherShop.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getOtherShopAction.rejected, (state, action) => {
            state.selectedOtherShop.apiMsg.message = action.error.message;
            state.selectedOtherShop.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(insertUpdateOtherShopAction.fulfilled, (state, action) => {
            if (!action.meta.arg) return;

            const newData = action.meta.arg;
            const payData = action.payload.data;
            const isNewRecord = !newData.BusinessID;
            // Ensure state.OtherShop is initialized
            state.OtherShop = state.OtherShop || { data: { records: [], totalRecords: 0 } };
            const existingRecords = state.OtherShop.data.records || [];

            const index = existingRecords.findIndex(record => record.businessID === newData.BusinessID);


            // Normalize latitude/longitude
            const toNumber = (value) => {
                if (value == null) return null; 
                return Number(value);           
            };

            const normalizedRecord = {
                businessID: newData.BusinessID || payData.data,
                active: newData.Active,
                address: newData.Address,
                billingAddress: newData.BillingAddress,
                billingCompanyName: newData.BillingCompanyName,
                email: newData.Email,
                latitude: newData.Latitude,
                longitude: newData.Longitude,
                name: newData.Name,
                orderMaxAmount: newData.orderMaxAmount,
                availableStockDisplay: newData.AvailableStockDisplay,
                storeCollectionEnable: newData.StoreCollectionEnable,
                storeCollectionWithCOD: newData.StoreCollectionWithCOD,
                homeDeliveryWithCOD: newData.homeDeliveryWithCOD,
                onlyInStockProductDisplay: newData.onlyInStockProductDisplay,
                parentBusinessID: newData.parentBusinessID,
                parentBusiness: newData.parentBusiness,
                shopCode: newData.shopCode,
            };
            if (index !== -1) {
                // Update record immutably
                state.OtherShop.data.records = [
                    ...existingRecords.slice(0, index),
                    normalizedRecord,
                    ...existingRecords.slice(index + 1),
                ];
            } else {
                // Add new record at the start
                state.OtherShop.data.records = [normalizedRecord, ...existingRecords];
                state.OtherShop.data.totalRecords = (state.OtherShop.data.totalRecords || 0) + 1;
            }

            state.insertUpdateOtherShop.data = normalizedRecord;
            state.insertUpdateOtherShop.newRecord = isNewRecord;
            state.insertUpdateOtherShop.apiMsg = {
                status: action.meta.requestStatus,
                message: action?.payload?.message?.message || "Success",
            };

            toast.success(state.insertUpdateOtherShop.apiMsg.message, {
                position: "bottom-center",
                toastId: "success",
            });
        });
        builder.addCase(insertUpdateOtherShopAction.pending,
            (state, action) => {
                state.insertUpdateOtherShop.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(insertUpdateOtherShopAction.rejected,
            (state, action) => {

                state.insertUpdateOtherShop.apiMsg.message = action.error.message;
                state.insertUpdateOtherShop.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: "bottom-center",
                    toastId: "error"
                });
            }
        );


        builder.addCase(OtherShopChangeStatusACTION.fulfilled, (state, action) => {
            if (action.meta.arg.StatusType === Enums.ChangeStatus.Delete) {
                const existingRecords = state.OtherShop.data.records;
                const roleIdToDelete = action.payload.data.Id;
                const updatedRecords = existingRecords.filter(record => record.businessID !== roleIdToDelete);
                state.OtherShop.data.records = updatedRecords;
                state.OtherShop.data.totalRecords = state.OtherShop.data.totalRecords - 1;
            }
            else {
                const newData = action.meta.arg;
                const existingRecords = state.OtherShop.data.records;
                // console.log("newData",newData)
                const index = existingRecords.findIndex(record => record.businessID === newData.Id);
                if (index !== -1) {
                    existingRecords[index] = {
                        ...existingRecords[index],
                        active: newData.active,
                    };
                }
                state.OtherShop.data.records = existingRecords;
            }

            state.deleteOtherShop.apiMsg.status = action.meta.requestStatus;
            state.deleteOtherShop.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(OtherShopChangeStatusACTION.pending, (state, action) => {
            state.deleteOtherShop.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(OtherShopChangeStatusACTION.rejected, (state, action) => {
            state.deleteOtherShop.apiMsg.message = action.error.message;
            state.deleteOtherShop.apiMsg.status = action.meta.requestStatus;
        });
    }
})

export const { RESET, ResetOtherShopDetailsState } = OtherShopReducer.actions;
export default OtherShopReducer.reducer;